export default __webpack_public_path__ + "static/media/2025-Scholarship-Application.68d80448.png";